import { render, staticRenderFns } from "./QuestionBox2.vue?vue&type=template&id=c7f5ff92&scoped=true&"
import script from "./QuestionBox2.vue?vue&type=script&lang=js&"
export * from "./QuestionBox2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7f5ff92",
  null
  
)

export default component.exports